window.addEventListener("load", (event) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams) {
        

        if (urlParams.has('scrolldown')) {
            const target = document.getElementById(urlParams.get('scrolldown'));

            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }
    }
});